import state from '../state';
import { next_frame } from '@vaaas/fpts/promise';
import { enumerate } from '@vaaas/fpts/iter';
import { size } from '../maths';
import { always_true, attempt } from '@phi/util';

export const withProgress = <T>(label: string, f: (x: T) => void | Promise<void>) => async (xs: Iterable<T>, len: number | undefined = undefined): Promise<void> => {
    const old = state.spinner;
    if (!len) len = size(xs) || 100;
    for (const [i, x] of enumerate(xs)) {
        state.spinner = `${label} (${Math.round(100*i/len)}%)`;
        const result = f(x);
        if (result instanceof Promise)
            await result;
        else
            await next_frame();
    }
    state.spinner = old;
    await next_frame();
};

export function withSpinner<I extends any[], R>(label: string, f: (...xs: I) => R | Promise<R>, should_show: (...xs: I) => boolean = always_true) {
    return async function withSpinner(...xs: I): Promise<R | Error> {
        if (!should_show(...xs))
            return f(...xs);
        const old = state.spinner;
        state.spinner = label;
        await next_frame();
        if (old === undefined)
            await next_frame();
        const x = await attempt(() => f(...xs));
        if (state.spinner !== undefined) {
            state.spinner = old;
            await next_frame();
        }
        return x;
    };
}
